// extracted by mini-css-extract-plugin
export var activeDot = "_1y-c";
export var buttonContainer = "_1y-9";
export var channelButton = "_1y-a";
export var clickable = "_1y-d";
export var content = "_1y-0";
export var contentFull = "_1y-2";
export var contentThird = "_1y-1";
export var contentWrapper = "_1y-7";
export var description = "_1y-5";
export var heightShort = "_1y-f";
export var image = "_1y-3";
export var imageContainer = "_1y-4";
export var selectButton = "_1y-e";
export var spinnerContainer = "_1y-b";
export var titleContent = "_1y-8";
export var titleWrapper = "_1y-6";